import { computed, ref, watch } from '@vue/composition-api';
import { useStorage } from '@vueuse/core';
const GOGO_SWITCH_KEY = 'wuji:gogo:open';
// 是否在部署配置中开启功能
export const getDeployOpen = () => window?.GLOBAL_INFO?.wujiGoConfig?.enable || false;
// 是否在 Query 参数中开启测试模式
export const getSearchDevOpen = () => new URLSearchParams(window.location.search).has('gogoDev');
// 获取测试版本地址
export const getTestBaseUrl = () => new URLSearchParams(window.location.search).get('testBaseUrl');
const isLocalGogoOpen = useStorage(GOGO_SWITCH_KEY, false);
export function useGogo() {
    const isDeployOpen = ref(getDeployOpen());
    const isSearchDevOpen = ref(getSearchDevOpen());
    const isOpen = computed(() => isDeployOpen.value || isSearchDevOpen.value || isLocalGogoOpen.value);
    // 如果 Query 中开启过测试模式，则本地存储为开启状态
    watch(isSearchDevOpen, (val) => {
        if (val)
            isLocalGogoOpen.value = true;
    }, { immediate: true });
    return {
        isOpen,
    };
}
